require('../../../assets/lib/angularJS-NES/angular-sanitize.min.js');
require('../../../assets/scripts/source/person/JV.NewPerson.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/directives/jv.FormTemplate.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');
require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/scripts/common/directives/jv.HideOnBlur.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.webpack.js');
require('../../../assets/lib/angular/angular-ui.js');
require('../../../assets/lib/angularJS-NES/angular-cookies.min.js');
require('../../../assets/scripts/common/directives/jv.LoadingButton.js');
require('../../../assets/scripts/common/jv.TextUtil.js');
require('../../../assets/scripts/common/jv.EmployeeSelect.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/source/jv.source.modal-adapter.service.js');
require('../../../assets/scripts/source/contacts/JV.ContactConstants.js');
require('../../../assets/scripts/source/contacts/JV.ContactModal.js');
require('../../../assets/scripts/source/contacts/JV.ContactService.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.svc.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/common/directives/jv.simple-select.directive.js');
require('../../../assets/scripts/source/contacts/JV.ContactList.js');
require('../../../assets/scripts/source/contacts/JV.ImportContacts.js');